var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 6.1 6.1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86478143,0.0846208384 L0.372625272,1.0191794 C0.148570848,1.10305004 0,1.3187174 0,1.5583478 L0,4.25538795 C0,4.47345161 0.123409656,4.67234485 0.31751028,4.76939516 L2.80966644,6.01547324 C2.97141696,6.09694757 3.16192313,6.09694757 3.32367365,6.01547324 L5.81582981,4.76939516 C6.01112858,4.67234485 6.13334009,4.47225346 6.13334009,4.25538795 L6.13334009,1.5583478 C6.13334009,1.3187174 5.98476924,1.10424819 5.76071482,1.02037755 L3.26855866,0.0858189904 C3.13915824,0.0354966064 2.99538,0.0354966064 2.86478143,0.0846208384 Z M3.06726912,0.82867323 L5.36772096,1.69134267 L5.36772096,1.70452234 L3.06726912,2.6390809 L0.76681728,1.70452234 L0.76681728,1.69134267 L3.06726912,0.82867323 Z M3.45067776,5.09409435 L3.45067776,3.31004602 L5.36772096,2.53124722 L5.36772096,4.13557275 L3.45067776,5.09409435 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.14c45a69d20e86b58b2249f23c568c5c.svg";
export { ForwardRef as ReactComponent };